// extracted by mini-css-extract-plugin
export default {"parent":"warning_parent__-q1fo","parentActions":"warning_parentActions__uKgxC","parentActionButton":"warning_parentActionButton__qu+qU"};